import React from "react";
import "./css/Services.css";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { Container } from "@mui/material";

export default function Services() {
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  return (
    <div>
      <div className="features">
        <div className="row">
          <div className="img-col">
            <img alt=".." src="Minimalist Mascot Phone Logo.gif" />
          </div>
          <div className="text-col">
            <h1 style={{ alignItems: "centre" }}>Service</h1>
            <p style={{ width: "100%", fontWeight: "300" }}>
              We are working and offering variety of services which helps user
              to be secure from day to day malicious activity that may harm and
              squander us without our consciousness.
            </p>
          </div>
        </div>
      </div>
      <Container className="grid-service">
        <Grid container rowSpacing={10} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            <Item data-aos="flip-left">
              <div class="card">
                <div class="icon-wrapper">
                  <center>
                    <i class="fas fa-wrench"></i>
                  </center>
                </div>
                <h1>File Detection</h1>
                <p class="body-text">
                  Detects harmful malwares and viruses in files (PDF, Image etc)
                  and removes them from system permanently.
                </p>
              </div>
            </Item>
          </Grid>
          <Grid item xs={6}>
            <Item data-aos="flip-right">
              <div class="card">
                <div class="icon-wrapper">
                  <center>
                    <i class="fas fa-truck-pickup"></i>
                  </center>
                </div>
                <h1>Junk Detection</h1>
                <p class="body-text">
                  Detects harmful malwares and viruses in files (PDF, Image etc)
                  and removes them from system permanently.
                </p>
              </div>
            </Item>
          </Grid>
          <Grid item xs={6}>
            <Item data-aos="flip-up">
              <div class="card">
                <div class="icon-wrapper">
                  <center>
                    <i class="fas fa-wrench"></i>
                  </center>
                </div>
                <h1>URL Detection</h1>
                <p class="body-text">
                  Scans and detects malicious, harmful and phishing URL, which
                  once clicked can even create squander for user.
                </p>
              </div>
            </Item>
          </Grid>
          <Grid item xs={6}>
            <Item data-aos="flip-down">
              <div class="card">
                <div class="icon-wrapper">
                  <center>
                    <i class="fas fa-hammer"></i>
                  </center>
                </div>
                <h1>Deep Scan</h1>
                <p class="body-text">
                  Scans complete system, and detects for malicious files and
                  folder with real time protection.{" "}
                </p>
              </div>
            </Item>
          </Grid>
        </Grid>
      </Container>

      <div></div>
    </div>
  );
}
